import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollTrackerService {
  private savedX: number = 0;
  private savedY: number = 0;
  /**
   * Save current scroll coordinates
   */
  storePosition(currentY: number, currentX: number = 0): void {
    this.savedY = currentY;
    this.savedX = currentX;
  }
  /**
   * Retrieve stored position
   */
  get position(): { top: number; left: number } {
    return { top: this.savedY, left: this.savedX };
  }
  /**
   * Reset stored scroll position
   */
  reset(): void {
    this.savedY = 0;
    this.savedX = 0;
  }
  /**
   * Compare current scroll with saved one
   */
  hasMoved(latestY: number, latestX: number = 0): boolean {
    return this.savedY !== latestY || this.savedX !== latestX;
  }
  /**
   * Check if page scroll is different from last saved
   */
  isPageMoved(): boolean {
    return this.hasMoved(window.scrollY, window.scrollX);
  }
}